<div class="pd-content-container">
    <!-- Spinner while download detail is being loaded -->
    <div *ngIf="loading && !loadError" class="pd-loader">
        <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
    </div>

    <!-- Error loading content -->
    <div *ngIf="!loading && loadError" class="pd-permission-error">
        <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
        There was an error loading previous versions of the {{ downloadType }}. Click below try again.
        <button hc-button size="lg" (click)="loadDownloads(downloadType)">Reload Download Details</button>
    </div>

    <div class="product-catalog-table-container" [hidden]="loadError || loading">
        <div class="download-detail-header">
            <h2>{{typeName}} Version History</h2>
        </div>
        

        <table hc-table [borders]="false" [dataSource]="dataSource" hcSort>
            <!-- Version Column -->
            <ng-container hcColumnDef="version">
                <th hc-index-cell *hcHeaderCellDef hc-sort-header id="versionHeader">Version</th>
                <td hc-index-cell *hcCellDef="let element">{{ element.version }}</td>
            </ng-container>

            <!-- Name Column -->
            <ng-container hcColumnDef="name">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Name</th>
                <td hc-cell *hcCellDef="let element">{{ element.name }}</td>
            </ng-container>
    
            <!-- Start Date Column -->
            <ng-container hcColumnDef="startDate">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="startDateHeader">Start Date</th>
                <td hc-cell *hcCellDef="let element">{{ element.startDate | date: 'shortDate' }}</td>
            </ng-container>
    
            <!-- End Date Column -->
            <ng-container hcColumnDef="endDate">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="endDateHeader">End Date</th>
                <td hc-cell *hcCellDef="let element">{{ element.endDate | date: 'shortDate' }}</td>
            </ng-container>

            <!-- Publish Date Column -->
            <ng-container hcColumnDef="publishDate">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="publishDateHeader">Publish Date</th>
                <td hc-cell *hcCellDef="let element">{{ element.publishDate | date: 'shortDate' }}</td>
            </ng-container>

            <!-- Icon Actions Column -->
            <ng-container hcColumnDef="actions" justify="center">
                <th hc-header-cell *hcHeaderCellDef id="actionsHeader"></th>
                <td hc-cell *hcCellDef="let element">
                    <div class="hc-table-actions">
                        <a *ngIf="downloadType === 'techlibrary'" hcMenuIcon class="fa fa-history hc-action-ico action-ico-anchor" hcTooltip="View change log" [href]="'/changes?id=' + element.name" target="_blank"></a>
                        <a hcMenuIcon class="fa fa-download hc-action-ico action-ico-anchor" hcTooltip="Download PDF file" [href]="'/tech-catalog?name=' + element.name" target="_blank"></a>
                    </div>
                </td>
            </ng-container>

            <tr hc-header-row *hcHeaderRowDef="displayedColumns"></tr>
            <tr hc-row *hcRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
            <span class="hc-empty-table-block-ico hc-empty-ico"></span>
            <span class="hc-empty-table-block-msg">No versions are available.</span>
        </div>
        <hc-pagination [length]="listLength" [pageSize]="pageSize" [hidden]="loadError || loading"></hc-pagination>
    </div>
</div>